type NormalizeFn = (value: string, normalizedValue?: any) => any;

export const normalizeNumber: NormalizeFn = (
  value: string,
  normalizedValue = null,
) => {
  if (Number.isNaN(Number(value)) || value === '') {
    return normalizedValue;
  }

  return Number(value);
};
